// extracted by css-extract-rspack-plugin
module.exports =  {"successWrap":"mEz6f","sucTitle":"ogyXC","shareBox":"hoier","shareTitle":"Sf9k6","sucImgWrap":"Vk2zp","buttonWrap":"RVXx9","button":"s8egw","sucContent":"mGROC"};